import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { environment } from "../../../environments/environment";
@Injectable({
  providedIn: "root",
})
export class CommonDataSharingService {
  private readonly SECRET_KEY: string = "IM1s5OqAYE9XoNyr7txjPXiuDO2WoZCt";
  private readonly SECRET_IV: string = "ST9KKWIeZtw0Onu1";
  private agencyCode = (environment as any).agencyCode;

  constructor() { }

  encryptData(data: any): string {
    const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
    const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
    // Convert data to JSON string
    const payload: any = { ...data, agencyCode: this.getAgencyCode() }; // patch agencyCode
    // const payload: any = { ...data, agencyCode: this.agencyCode }; // patch agencyCode
    // console.log("payload-------->", payload);
    const stringifyJsonData = JSON.stringify(payload);
    // Encrypt the JSON string
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(stringifyJsonData), // Convert string to WordArray
      secretKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Return encrypted data as a Base64 string
    return encrypted.toString();
  }

  getAgencyCode = () => window.location.host.split(".")[0];

  decryptData(apiRes: string): any {
    const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
    const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
    // Decrypt the encrypted text
    const decrypted = CryptoJS.AES.decrypt(apiRes, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return decryptedText;
  }

  JSONFormatter = (data: any) => JSON.parse(data);
  // JSONFormatter(data: any): any {
  //   console.log(
  //     JSON.parse(data)?.message
  //       ? JSON.parse(data)?.message + "------"
  //       : "JSONFormatter------",
  //     JSON.parse(data)
  //   );
  //   return JSON.parse(data);
  // }

  sanitizeImage(base64Data: string): string {
    if (!base64Data) return "";

    base64Data = base64Data.trim(); // Remove unnecessary spaces

    // If it already starts with a valid base64 prefix, return it
    if (base64Data.startsWith("data:image")) {
      return base64Data;
    }

    // Determine the appropriate image type and prepend the prefix
    const validPrefixes = [
      "data:image/png;base64,",
      "data:image/jpeg;base64,",
      "data:image/jpg;base64,",
    ];
    const detectedPrefix = validPrefixes.find((prefix) =>
      base64Data.includes(prefix)
    );

    return detectedPrefix ? base64Data : `data:image/png;base64,${base64Data}`;
  }
}
